import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import { Button } from '@paypalcorp/pp-react';
import * as analytics from '../lib/analytics';
import { isPPGF } from '../lib/charity';
import styles from './donateButton.less';
import { DataContext } from '../lib/context';

export default class extends React.Component {
  static contextType = DataContext;
  static contextTypes = {
    csrf: PropTypes.string,
  };

  static defaultProps = {
    active: true,
  };

  static propTypes = {
    charity: PropTypes.object,
    charityDetails: PropTypes.object,
    virtualCharity: PropTypes.object,
    amounts: PropTypes.object,
    isGroupDonation: PropTypes.bool,
    coBrand: PropTypes.string,
    formUrl: PropTypes.string,
    elmo: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      nemoTag: props.isGroupDonation ? 'gtg' : 'charity',
    };
  }

  recordDonateButtonPressed = () => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_DETAIL_DONATE_PRESSED,
      {
        e: 'cl',
        product: 'dw_giving',
        flow: 'PP_FUNDRAISING',
        tile_id: 'charity profile page',
        event_source: analytics.getEventSource(this.props.isMobile),
        account_type: analytics.getAccountType(this.props.authState),
        acct_cntry: this.props.contentCountry,
        crid: this.props.charity
          ? this.props.charity.nonprofit_id
          : this.props.charityDetails.nonprofit_id,
        charityname: this.props.charity
          ? this.props.charity.name
          : this.props.charityDetails.name,
        nonanonymous: false,
        amount: 0,
        currency_code: this.props.amounts.currencyCode || '',
        encr_rcvr_id: this.props.charity ? this.props.charity.payerId : '',
        xe: this.props.elmo.idExperiments,
        xt: this.props.elmo.idTreatments,
      }
    );
  };

  handleDonateClick = async (event) => {
    this.recordDonateButtonPressed();
    let npid, charityType, charityName, formUrl;
    if (this.props.charity) {
      npid = this.props.charity.nonprofit_id;
      charityType = this.props.charity.charity_type;
      charityName = this.props.charity.name;
      formUrl = this.props.formUrl;
    } else {
      npid = this.props.charityDetails.nonprofit_id;
      charityType = this.props.charityDetails.charity_type;
      charityName = this.props.charityDetails.name;
      formUrl = `${this.props.coBrand}charity/${npid}/donate/createDnwToken`;
    }

    let name;
    if (isPPGF(charityType)) {
      name = this.props.i18n('label.ppgf-donation-description', {
        charity: this.props.isGroupDonation
          ? this.props.virtualCharity.name
          : charityName,
      });
    } else {
      name = this.props.i18n('label.donation-description', {
        charity: this.props.isGroupDonation
          ? this.props.virtualCharity.name
          : charityName,
      });
    }

    let charityNpid = this.props.isGroupDonation
      ? this.props.charity.groupVirtualNpid
      : npid;

    const params = {
      _csrf: this.props.csrf || this.context.csrf,
      name: name,
      npid: charityNpid,
      anonymous: isPPGF(this.props.charity_type) ? 'true' : 'false',
      currency: this.props.amounts.currencyCode,
      charityType: this.props.charity_type,
    };

    fetch(formUrl, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        // Redirect when charity not found
        // due to charity country doesn't match with hub country
        if (response.redirected) {
          window.location.href = response.url;
        }

        if (response.status < 400) {
          return response.json();
        }
      })
      .then((data) => {
        if (this.props.elmo.hasDnwFullPageTrmt) {
          window.location.href = data.executeUrl;
        } else {
          // eslint-disable-next-line new-cap
          const instance = window.Donation.Checkout({
            baseUrl: data.executeUrl,
            token: data.id,
            onComplete: function (params) {},
          });
          instance.renderTo(window);
        }
      });

    analytics.trackLinkWithData(
      `${this.props.isGroupDonation ? 'gtgdonateButton' : 'donateButton'}`,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      {
        nonanonymous: this.state.nonanonymous,
        crid: npid,
      },
      'link'
    );
  };

  donationForm = () => {
    const ShowDonateButton = () => (
      <Button
        className={styles.donateButton}
        type={'submit'}
        onClick={(e) => this.handleDonateClick(e)}
        id={`nemo_donatebutton_${this.state.nemoTag}`}
      >
        {this.props.donateButtonText
          ? this.props.donateButtonText
          : this.props.i18n('label.donate-button')}
      </Button>
    );

    return (
      <div>
        <ShowDonateButton />
      </div>
    );
  };

  render() {
    return <div>{this.donationForm()}</div>;
  }
}
